<template>
  <div class="container">
    <div class="account" v-show="isA">
       <span>{{$t('Find account')}}</span>
       <img src="../assets/User-1.png">
       <p :class="{'zh':styleChange}">{{$t('Enter username')}}</p>
       <div class="icon-bor"  :class="{'in': isE }">
         <div :class="{'in1': isE }">
           <img src="../assets/User.png">
         </div>
         <input type="text" :placeholder=user v-model="username" @focus="check4()" @blur="check4()">
       </div>
       <button class="next" @click="check1(0)">{{$t('Next')}}</button>
       <button class="cancel" v-show="udHcp" @click="goHome()">{{$t('Back')}}</button>
       <button class="cancel" v-show="!udHcp" @click="goHome()">{{$t('Back')}}</button>
    </div><!--account结束-->

    <div class="verify" v-show="isB"  >
      <span>{{$t('Enter veri')}}</span>
      <img src="../assets/Verfication Code.png">
       <p v-show="!isZh">{{$t('VcodeTip1')}}<span class="tryAgain" @click="sendSeccode1" :class="{'disAble':tryAgain}">{{$t('VcodeTip2')}}</span>{{$t('VcodeTip3')}}
        <span class="userName">{{username}}</span></p>
       <p v-show="isZh">{{$t('VcodeTip1')}}<span class="userName">{{username}}</span>{{$t('VcodeTip2')}}
        <span class="tryAgain" @click="sendSeccode1" :class="{'disAble':tryAgain}">{{$t('VcodeTip3')}}</span>
        </p>
      <div class="icon-bor icon-spe2" :class="{'in': isE }">
        <input type="text" :placeholder=veri @focus="check4()" @blur="check4()" v-model="Vcode">
      </div>
       <button class="next" @click="check2(0)">{{$t('Next')}}</button>
       <button class="cancel" @click="check1(1)">{{$t('Back')}}</button>
    </div><!--verify结束-->

    <div class="create" v-show="isC">
      <span>{{$t('Create new')}}</span>
      <img src="../assets/New password.png">
      <p>{{$t('Create new notice')}}</p>
      <div class="icon-bor" :class="{'in': isE }">
        <div :class="{'in1': isE }" >
           <img src="../assets/Password.png">
        </div>
        <input  v-show="!isF" type="password" :placeholder=newpass autocomplete="new-password" @focus="check4()" @blur="check4()" v-model="password">
        <input v-show="isF"  type="text"  :placeholder=newpass autocomplete="new-password" @focus="check4()" @blur="check4()" v-model="password">
        <div id="type"  :class="[ isF ?'hide':'nohide']" @click="choose">
            <input type="checkbox">
        </div>
      </div>
      <button class="next"  @click="check3()">{{$t('Next')}}</button>
      <button class="cancel" @click="check2(1)">{{$t('Back')}}</button>
    </div><!--create结束-->

    <div class="completed" v-show="isD">
      <span>{{$t('Completed')}}</span>
      <img src="../assets/Completed.png">
      <p :class="{'zh':styleChange}">{{$t('Created')}}</p>
      <button class="sign"  v-show="udHcp"  @click="goHome()">{{$t('Login Now')}}</button>
      <button class="sign" v-show="!udHcp"  @click="goHome()">{{$t('Login Now')}}</button>
    </div><!--completed结束-->
  </div>
</template>

<script>
  import auth from '../auth/auth'
  import B64 from '../auth/base64'
  export default {
    data() {
      return {
        username: '',tryAgain:false,isZh:false,
        Vcode:'',
        password: '',
        error: '',
        send:this.$t('send'),
        canClick:false,
        user:this.$t('user'),
        veri:this.$t('Entercode'),
        newpass:this.$t('New pass'),
        styleChange:(this.$store.state.language==='zh') ? true:false ,  token:'',passwordToken:'',
        isA:true, isB:false, isC:false, isD:false,
        isE:false,
        isF:false,udHcp:true,
      }
    },
    computed:{
      getLanguage(){
        return this.$store.state.language;
      }
    },
    watch:{
      getLanguage(val){
        this.user = this.$t('user');
        this.send = this.$t('send');
        if(val==='zh'){
          this.styleChange =true;
        }else{
          this.styleChange =false;
        }
      }
    },
    methods: {
      check1(flag){
          if(flag===0){
            if(this.username===""){
              let tip = this.$t('enterEmTip');
              this.$message.error(tip);
            }else{
              this.$http.get('api/v2.0/user/'+this.username).then(function(res){
                let exist =res.body.exist;
                if(exist){
                  this.isA = false;
                  this.isB = true;
                  sessionStorage.setItem('A',0);
                  sessionStorage.setItem('B',1);
                  this.sendSeccode2();
                }else{
                  let tip = this.$t('userNotExist');
                  this.$message.error(tip);
                }
              });
            }
          }
          if(flag===1){
            this.isA = true;
            this.isB = false;
            sessionStorage.setItem('A',1);
            sessionStorage.setItem('B',0);
          }
      },
      sendSeccode1(){
        if(!this.tryAgain){
          this.sendSeccode2();
          let tip = '';
          if(this.isZh){
            tip = this.$t('VcodeTip1')+' '+this.username;
          }else{
            tip = this.$t('VcodeTip3')+' '+this.username;
          }
          this.$message({
            type: 'success',
            message:tip
          });
          this.tryAgain =true;
        }
      },
      sendSeccode2(){
        let para = {
          user_name:this.username,
          country:'CN',
          flag:'' ,
          purpose:'findpw',
        };
        if(this.username.indexOf('@')=== -1){
          para.flag = 'mobile';
        }else{
          para.flag = 'email';
        }
        auth.sendSeccode(this,para);
        auth.setTime(this);
      },
      check2(flag){
          let param ={
            seccode:this.Vcode,
            token:this.token,
          };
        param = B64.base64encode(JSON.stringify(param));

        if(flag===0){
          auth.getToken(this,param);
        }
        if(flag===1){
          this.isB = true;
          this.isC = false;
          sessionStorage.setItem('B',1);
          sessionStorage.setItem('C',0);
        }
      },
      check3(){
          let para = {
            username:this.username,
            new_password:this.password,
            token:this.passwordToken,
          };
        auth.resetPassword(this,para);
      },
      check4(){
        this.isE = !this.isE;
        if(this.user === ''){
          this.user = this.$t('user');
        }else{
          this.user = '';
        }
        if(this.veri === ''){
          this.veri = this.$t('Entercode');
        }else{
          this.veri = '';
        }
        if(this.newpass === ''){
          this.newpass = this.$t('New pass');
        }else{
          this.newpass = '';
        }
      },
      choose(){
        this.isF = !this.isF;
      },
      goHome(){
          if(this.udHcp){
              this.$router.push('/login');
          }else{
              this.$router.push('/hcpLogin');
          }
      }
    },
    beforeDestroy(){
      sessionStorage.removeItem('udHcp');
    },
    mounted(){
     /*  if(sessionStorage.getItem('A')){
         this.isA =(sessionStorage.getItem('A')==='1')?true:false;
         this.isB =(sessionStorage.getItem('B')==='1')?true:false;
         this.isC =(sessionStorage.getItem('C')==='1')?true:false;
         this.isD =(sessionStorage.getItem('D')==='1')?true:false;
        // console.log(this.isC,this.isD);
       }*/
      if(sessionStorage.getItem('udHcp')){
        this.udHcp = (sessionStorage.getItem('udHcp')==='1')?true:false;
      }
      let lang = sessionStorage.getItem('language');
      this.isZh = (lang==='zh'||lang==='hk')?true:false;
    },
  }
</script>

<style scoped>
  .container{
    width:400px;
    height:570px;
    margin: 0 auto;
    background: rgba(235,238,241,0.6);
    border-radius:14px;
  }
  .account,.verify,.create,.completed{
    width:100%;
    padding-top: 30px;
  }
  .container span{
    font-family:SFUIText-Medium;
    height:35px;
    font-size:26px;
    display: block;
    color:#323232;
    letter-spacing:-0.63px;
    line-height:35px;
    text-align:center;
    margin:0 auto 55px;
  }
  .container img{
    width:90px;
    height:90px;
    margin:0 auto;
    display: block;
  }
  .container p{
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#323232;
    letter-spacing:-0.49px;
    line-height:21px;
  }
  .account p{
    margin: 55px auto 90px;
    text-align: center;
  }
  .account .zh{
    margin: 55px auto 69px;
  }
  .icon-bor{
    opacity:0.8;
    background:#ffffff;
    box-shadow:0 2px 7px 0 rgba(210,210,210,0.50);
    border-radius:100px;
    width:324px;
    height:45px;
    margin:0 auto 30px;
  }
  .icon-bor img{
    display:block;
    width:20px;
    height:23px;
    margin:11px 22px 12px 17px;
    float:left;
  }
  .icon-bor input{
    height:30px;
    width:220px;
    line-height: 30px;
    font-size:20px;
    color:#282828;
    letter-spacing:-0.69px;
    text-align:left;
    border: none;
    margin-top: 8px;
    font-family:SFUIText-Regular;
  }
  .icon-bor input:focus{
    color: #2aace0;
    border: none;
    outline:none;
  }
   button{
    height:45px;
    width:324px;
    margin:0 36px;
    border:none;
    font-family: SFUIText-Medium;
    outline: none;
  }
  .next{
    background:#009fdf;
    border-radius:100px;
    font-size:20px;
    margin-bottom: 20px;
    color:#f6f9fb;
    letter-spacing:-0.69px;
    text-align:center;
    opacity:0.8;
    cursor:pointer;
  }
  .next:hover{
    opacity:0.6;
  }
  .cancel{
    height: 21px;
    font-family:SFUIText-Regular;
    font-size:18px;
    color:#2aace0;
    letter-spacing:-0.44px;
    text-align:center;
    background-color: transparent;
    outline: none;
    cursor:pointer;
  }
  .cancel:hover{
    opacity: 0.7;
  }

  /*verify部分*/
  .verify p{
    text-align:left;
    width:330px;
    margin: 53px 0 50px 55px;
  }
  .verify .tryAgain{
    font-family:SFUIText-Regular;
    font-size:20px;
    letter-spacing:-0.49px;
    line-height:21px;
    display: inline;
    margin:0  4px ;
    color:#2aace0;
    cursor: pointer;
  }
  .verify .userName{
    font-family:SFUIText-Regular;
    font-size:20px;
    letter-spacing:-0.49px;
    line-height:21px;
    display: inline;
    margin:0  2px ;
    color:#323232;
  }
  .verify .disAble{
    color:#323232;
    cursor: auto;
  }
  .icon-spe2 input{
    height:30px;
    width:180px;
    margin-left:22px;
  }
  .time{
    background:#009fdf;
    box-shadow:0 2px 7px 0 rgba(210,210,210,0.50);
    width:80px;
    height:45px;
    float:right;
    margin-left:34px;
    border-top-right-radius: 100px;
    border-bottom-right-radius: 100px;
    cursor: pointer;
  }
   #send1{
    background: transparent;
    border:none;
    outline: none;
     width:44px;
     height:24px;
     margin-left:16px;
     cursor: pointer;
  }
  #send1 span{
    display: block;
    font-family: SFUIText-Regular;
    font-size:20px;
    color:#f6f9fa;
    margin-top:4px;
    letter-spacing:-0.49px;
    text-align:center;
  }
  .in{
    border:1px solid #009fdf;
    height:43px;
    width:322px;
  }
  .in1{
    margin-left:-1px;
    margin-top:-1px;
  }
  .in2{
    margin-right:-1px;
    margin-top:-1px;
  }

  /*create部分*/
  .create p{
    text-align:left;
    width:284px;
    margin: 53px 0 50px 55px;
  }
  .create input{
    float: left;
  }
  #type{
    height:20px;
    width:28px;
    float:left;
    margin:14px 0 15px 5px;
    cursor: pointer;
  }
  #type input{
    height:10px;
    width:28px;
    float:left;
    filter:alpha(opacity=0);
    opacity: 0;
    cursor: pointer;
  }
  .hide{
    background: url("../assets/Hide.png") left center no-repeat;
  }
  .nohide{
    background: url("../assets/No_Hide.png") 1px 3px no-repeat;
  }

  /*completed部分*/
  .completed p{
    margin: 53px auto 166px;
    text-align: center;
  }
  .completed .zh{
    margin: 53px auto 145px;
  }
  .sign{
    height:45px;
    width:324px;
    opacity:0.8;
    background:#009fdf;
    box-shadow:0 7px 40px 0 rgba(42,170,221,0.40);
    border-radius:100px;
    font-family:SFUIText-Regular;
    font-size:20px;
    color:#f6f9fb;
    letter-spacing:-0.49px;
    text-align:center;
    cursor: pointer;
  }
  .sign:hover{
    opacity: 0.6;
  }
</style>



// WEBPACK FOOTER //
// updatePassword.vue?6a078da0